import axios from 'axios'

export default {
  async getPolygon (id) {
    const response = await axios.get(`https://www.openstreetmap.org/api/0.6/way/${id}/full`)

    // https://stackoverflow.com/questions/55067273/osm-api-way-nodes-ordered-incorrectly/55068527#55068527
    const nodes = response.data.elements.filter(element => element.type === 'node')
    const ways = response.data.elements.filter(element => element.type === 'way')

    const refs = {}
    nodes.forEach(node => {
      refs[node.id] = [+node.lat, +node.lon]
    })

    const output = ways[0].nodes.map(node => {
      return refs[node]
    })

    return output
  }
}
